module.exports = __webpack_public_path__ + "static/media/MobileBg.e3956635.png";